<template>
    <v-container fluid>
      <field-form v-if="item" @save="save" :button-text="$t('campaigns.start')" button-color="error" :saving="saving" :wizard="wizard" :wizardSteps="currentWizard" :step="displayStep" :last-editable-step="lastEditableStep" :allow-editable="true" @cancel="cancelWizard()" @click-step="changeStep">
      <h2 class="text-h4">{{$t('campaigns.summary.title')}}</h2>
      <v-row>
        <!-- TEMPLATE
        <v-col  cols="12" sm="6" md="4" lg="3">
          <v-card>
            <v-card-title>Title</v-card-title>
            <v-list>
              <v-list-item>
                <v-list-item-icon><v-icon>$settings</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Name</v-list-item-subtitle>
                  <v-list-item-title>Value</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-card-actions>
              <v-btn color="primary" text :to="{name: 'campaign-edit' }"><v-icon left>$edit</v-icon>Change</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        -->
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-card
          id="pfid1618821334">
            <v-card-title>{{$t('common.name')}}</v-card-title>
            <v-list>
              <v-list-item>
                <v-list-item-icon><v-icon>$rename</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('common.name')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-card-actions>
              <v-btn color="primary" text :to="{name: 'campaign-segment' }"><v-icon left>$edit</v-icon>{{$t('dialog.change')}}</v-btn>
            </v-card-actions>
          </v-card>
          <v-card class="mt-3"
          id="pfid1618821342" >
            <v-card-title>{{$t('campaigns.mediumAndType.title')}}</v-card-title>
            <v-list>
              <v-list-item>
                <v-list-item-icon><v-icon>{{ typeIcon }}</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.mediumAndType.type')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ campaignType }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>{{ mediumIcon }}</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.mediumAndType.medium')}}</v-list-item-subtitle>
                  <v-list-item-title>E-mail</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
         <v-col cols="12" sm="6" md="4" lg="3">
          <v-card :loading="recipientsLoading"
          id="pfid1618821352">
            <v-card-title>{{$t('campaigns.segment.title')}}</v-card-title>
            <v-list v-if="!isSWU">
              <v-list-item>
                <v-list-item-icon><v-icon>$settings</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.segment.setup')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ segment }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="isTag">
                <v-list-item-icon><v-icon>$tag</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.segment.tag.title')}}</v-list-item-subtitle>
                  <v-list-item-title>{{item.segment.inverse ? $t('campaigns.segment.tag.inversePrefix') : ''}} {{ segmentTag }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="!isAllSegment && !isTag">
                <v-list-item-icon><v-icon>$segmentFrom</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('common.intervals.from')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.segment.from }} {{ segmentSuffix }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item  v-if="!isAllSegment && !isTag">
                <v-list-item-icon><v-icon>$segmentTo</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('common.intervals.to')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.segment.to }} {{ segmentSuffix }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="!isAllSegment && !isTag">
                <v-list-item-icon><v-icon>$calendarChoose</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.segment.evaluationPeriod.title')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.evaluationPeriod.window ? evaluationWindow : evaluationPeriod }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon color="primary">$segment</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.segment.recipients.title')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ this.item.scheduleType == 'BACK_TO_CART' ? $t('common.notApplicable') : this.item.expectedRecipients }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list v-else>
              <v-list-item>
                <v-list-item-icon><v-icon>$segment</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.segment.swu.count')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.segment.count }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>$calendarChoose</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.segment.swu.length')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.segment.duration }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon color="primary">$segment</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.segment.recipients.title')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ this.item.expectedRecipients }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-card-actions>
              <v-btn id="pfid1618851421" color="primary" text :to="{name: 'campaign-segment' }"><v-icon left>$edit</v-icon>{{$t('dialog.change')}}</v-btn>
            </v-card-actions>
          </v-card>
          <v-card
          id="pfid1618821376"  class="mt-3">
            <v-card-title>{{$t('campaigns.setup.message.title')}}</v-card-title>
            <v-list>
              <v-list-item>
                <v-list-item-icon><v-icon>$mailing</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.setup.sender.email')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ `${item.from}@${item.domain.dnsName}` }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>$rename</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.setup.sender.name')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.friendlyFrom }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>$mailing</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.setup.sender.replyTo')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.replyTo ? `${item.replyTo}@${item.domain.dnsName}` : $t('common.notSet') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>$ganalytics</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.setup.message.utmCampaign')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.utm.campaign }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-subheader>{{$t('campaigns.setup.subjects.title')}}</v-subheader>
              <template v-if="item.subjects">
              <v-list-item v-for="(s,i) in item.subjects" :key="i">
                <v-list-item-icon><v-icon>{{ subjectIcon(i) }}</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ s }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              </template>
              <v-list-item dense v-for="v in item.variants" :key="`var${v.id}sub`">
              <v-list-item-icon><v-icon :color="v.active? 'success' : 'grey'">$campaignVariant{{v.name}}</v-icon></v-list-item-icon>
              <v-list-item-content><v-list-item-title>{{ v.subject }}</v-list-item-title></v-list-item-content>
              </v-list-item>
            </v-list>
            <v-card-actions>
              <v-btn id="pfid1618851434" color="primary" text :to="{name: 'campaign-setup-email' }"><v-icon left>$edit</v-icon>{{$t('dialog.change')}}</v-btn>
            </v-card-actions>
          </v-card>
          

        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-card
          id="pfid1618821363" v-if="!item.variants">
            <v-card-title>{{$t('campaigns.design.title')}}</v-card-title>
            <v-list subheader>
              <template v-for="v in item.variants || [item]">
              <v-subheader v-if="v.name" :key="`var${v.id}sh`">{{$t('campaigns.design.variants.name', {name: v.name })}}</v-subheader>
              <v-list-item :key="`var${v.id}rec`">
                
                <v-list-item-icon><v-icon>$recommendation</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.design.recommendations.title')}}</v-list-item-subtitle>
                  <v-list-item-title> {{ $tc('campaigns.summary.recommendations.products', v.templateSpecs.recommendationsCount) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item :key="`var${v.id}new`">
                <v-list-item-icon><v-icon>$recommendation</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.summary.newProducts')}}</v-list-item-subtitle>
                  <v-list-item-title> {{ $tc('campaigns.summary.recommendations.products', v.templateSpecsNew.recommendationsCount) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item :key="`var${v.id}cat`">
                <v-list-item-icon><v-icon>$recommendation</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.summary.categoryProducts')}}</v-list-item-subtitle>
                  <v-list-item-title> {{ $tc('campaigns.summary.recommendations.products', v.templateSpecsCategories.reduce((sum, cat) => sum + cat.specs.recommendationsCount, 0)) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              </template>
            </v-list>
            <v-card-actions>
              <v-btn color="primary" text :to="{name: 'campaign-design-email' }"><v-icon left>$edit</v-icon>{{$t('dialog.change')}}</v-btn>
            </v-card-actions>
          </v-card>
          <v-card v-if="item.variants"
          id="pfid1618821363" >
            <v-card-title>{{$t('campaigns.design.title')}}</v-card-title>
            <v-list subheader>
              <v-subheader>{{$t('campaigns.design.recommendations.title')}}</v-subheader>
              <v-list-item dense v-for="v in item.variants" :key="`var${v.id}rec`">
              <v-list-item-icon><v-icon :color="v.active? 'success' : 'grey'">$campaignVariant{{v.name}}</v-icon></v-list-item-icon>
              <v-list-item-content><v-list-item-title>{{ $tc('campaigns.summary.recommendations.products', v.templateSpecs.recommendationsCount) }}</v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-subheader>{{$t('campaigns.summary.newProducts')}}</v-subheader>
              <v-list-item dense v-for="v in item.variants" :key="`var${v.id}new`">
              <v-list-item-icon><v-icon :color="v.active? 'success' : 'grey'">$campaignVariant{{v.name}}</v-icon></v-list-item-icon>
              <v-list-item-content><v-list-item-title>{{ $tc('campaigns.summary.recommendations.products', v.templateSpecsNew.recommendationsCount) }}</v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-subheader>{{$t('campaigns.summary.categoryProducts')}}</v-subheader>
              <v-list-item dense v-for="v in item.variants" :key="`var${v.id}cat`">
              <v-list-item-icon><v-icon :color="v.active? 'success' : 'grey'">$campaignVariant{{v.name}}</v-icon></v-list-item-icon>
              <v-list-item-content><v-list-item-title>{{ $tc('campaigns.summary.recommendations.products', v.templateSpecsCategories.reduce((sum, cat) => sum + cat.specs.recommendationsCount, 0)) }}</v-list-item-title></v-list-item-content>
              </v-list-item>
            </v-list>
            <v-card-actions>
              <v-btn color="primary" text :to="{name: 'campaign-design-email' }"><v-icon left>$edit</v-icon>{{$t('dialog.change')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        
        <v-col  cols="12" sm="6" md="4" lg="3">
          <v-card dark color="primary"
            id="pfid1618821392">
            <v-card-title>{{$t('campaigns.summary.plan.title')}}</v-card-title>
            <v-list color="primary">
              <v-list-item v-if="isScheduled || isSWU">
                <v-list-item-icon><v-icon>$calendarFrom</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.summary.plan.start')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ sendStart }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="isAutomatic">
                <v-list-item-icon><v-icon>$messageFrequency</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.summary.plan.frequency')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ frequency }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="isBTC || isWelcome">
                <v-list-item-icon><v-icon>$messageDelay</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.summary.plan.delay')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ delay }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-card-actions>
              <v-menu v-if="isScheduled || isSWU" offset-y top :close-on-content-click="false" v-model="startPicker">
              <template v-slot:activator="{ on, attrs }">
               <v-btn id="pfid1618851485" text v-on="on" v-bind="attrs" ><v-icon left>$edit</v-icon>{{$t('campaigns.summary.plan.setStart')}}</v-btn>
              </template>
                <v-card style="height: 460px">
                  <v-tabs vertical v-model="startPickerTabs" grow>
                    <v-tab><v-icon>$date</v-icon></v-tab>
                    <v-tab><v-icon>$time</v-icon></v-tab>
                 
                    <v-tab-item>
                      <v-date-picker :locale="locale" :first-day-of-week="item.domain.firstDayOfWeek" style="height: 400px" @input="startPickerTabs += 1" v-model="startPickerDate"
                      id="pfid1618851479" ></v-date-picker>
                    </v-tab-item>
                    <v-tab-item>
                      <v-time-picker style="height: 400px" id="pfid1618851502" tile format="24hr" v-model="startPickerTime"></v-time-picker>
                    </v-tab-item>
                  </v-tabs>
                  <v-card-actions>
                    <v-btn id="pfid1618851491" text @click="setStartDate"><v-icon left>$ok</v-icon>{{$t('form.select')}}</v-btn>
                    <v-btn id="pfid1618851494" text @click="startDate = null; startPickerDate = null; startPickerTime = null; startPicker=false;"><v-icon left>$nok</v-icon>{{$t('form.clear')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
              <v-menu v-if="isAutomatic" offset-y top :close-on-content-click="true">
              <template v-slot:activator="{ on, attrs }">
               <v-btn id="pfid1618851515" text v-on="on" v-bind="attrs" ><v-icon left>$edit</v-icon>{{$t('campaigns.summary.plan.setFrequency')}}</v-btn>
              </template>
                <v-list dense>
                  <v-list-item-group v-model="frequencyIndex">
                  <v-list-item v-for="(f,i) in frequencies" :key="i">
                    <!-- <v-badge v-if="f.premium" color="success" icon="$premium"></v-badge> -->
                    <v-list-item-icon>
                      <v-icon v-if="f.premium" color="success">$premium</v-icon>
                      <v-icon v-else>$ok_outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ f.text }}<span v-if="f.premium"> (Premium)</span></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
              <v-menu v-if="isAutomatic" offset-y top :close-on-content-click="false" v-model="priorityMenu">
              <template v-slot:activator="{ on, attrs }">
               <v-btn id="pfid1618851530" text v-on="on" v-bind="attrs" ><v-icon left>$edit</v-icon>{{$t('campaigns.summary.plan.setPriority')}}</v-btn>
              </template>
                <campaign-priority-control :campaigns="listAutomatic" :movable="item.id" @confirm="savePriority" @cancel="priorityMenu = false"/>
              </v-menu>
              <v-menu v-if="isBTC || isWelcome" offset-y top :close-on-content-click="true">
              <template v-slot:activator="{ on, attrs }">
               <v-btn id="pfid1618851540" text v-on="on" v-bind="attrs" ><v-icon left>$edit</v-icon>{{$t('campaigns.summary.plan.setDelay')}}</v-btn>
              </template>
                <v-list dense>
                  <v-list-item-group v-model="delayIndex">
                  <v-list-item v-for="(f,i) in delays" :key="i">
                    <v-list-item-icon>
                      <v-icon>$ok_outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ f.text }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </v-card-actions>
          </v-card>
          <v-card id="pfid1618851765"  class="mt-3">
            <v-card-title>{{$t('campaigns.summary.preview.title')}}</v-card-title>
            <v-list dense>
              <v-list-item>
                <v-list-item-icon><v-icon>$mailing</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-text-field id="pfid1618851769" dense :label="$t('campaigns.summary.preview.recipient')" :placeholder="$t('campaigns.summary.preview.recipient')" v-model="recipient" :rules="[rules.email]" clearable></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="item.variants">
                <v-list-item-icon><v-icon>$variants</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-select
                    :items="item.variants.map(v => ({ text: v.name, value: v.id}))"
                    :label="$t('campaigns.detail.variants.variant')"
                    :placeholder="$t('campaigns.summary.preview.randomVariant')"
                    persistent-placeholder
                    v-model="previewVariant"
                    clearable
                    dense
                  ></v-select>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-card-actions>
              <v-btn id="pfid1618851550" :loading="sending" color="primary" text @click="sendPreview"><v-icon left>$send</v-icon>{{$t('campaigns.summary.preview.send')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>  
      </v-row>
      </field-form>
      <v-skeleton-loader v-else type="card,card,card" />
    </v-container>
</template>
<script>

  import EntityForm from "@/mixins/entity-form"
  import Wizards from "@/mixins/wizards"
  import ConfirmLeave from '@/mixins/confirm-leave'
  import Formatters from "@/mixins/formatters"
  import CampaignFormatters from "@/mixins/campaign-formatters"
  import CampaignPriorityControl from "@/components/CampaignPriorityControl"
  import { mapGetters, mapState } from "vuex"
  import Timezones from "@/mixins/timezones"

  export default {
    mixins: [EntityForm, Wizards, ConfirmLeave, Formatters, CampaignFormatters, Timezones],
    components: {CampaignPriorityControl},
    name: 'Summary',
    data() {
      return {
        endpoint: 'campaigns',
        fields: {
          schedule: null,
          state: null,
          priority: null
        },
        recipient: this.$store.getters['auth/email'],
        previewVariant: null,
        sending: false,
        recipientsLoading: false,
        startDate: null,
        startPicker: false,
        startPickerDate: null,
        startPickerTime: null,
        startPickerTabs: 0,
        frequencyIndex: null,
        delayIndex: null,
        priorityMenu: false
      }
    },
    computed: {
      frequency() {
        return this.frequencies[this.frequencyIndex]?.text || this.$t('common.notSet');
      },
      delay() {
        return this.delays[this.delayIndex]?.text || this.$t('common.notSet');
      },
      wizardParams() {
        let p = {
        };
        if(this.item) {
          p.medium = this.item.medium?.toLowerCase() || 'email';
        }
        return p;
      },
      hasProductsInTemplate() {
        if(!this.item) {
          return false;
        }

        let sum = (this.item.variants || [this.item]).reduce((vsum, v) => {
        
          return vsum + v.templateSpecs.recommendationsCount + v.templateSpecsNew.recommendationsCount + v.templateSpecsCategories.reduce((csum, cat) => csum + cat.specs.recommendationsCount, 0)
        }, 0);
        console.debug('hasProductsInTemplate sum', sum);
        return sum > 0;
        
      },
      ...mapGetters('campaigns', ['listAutomatic']),
      ...mapGetters('domains', ['isActive','isIncomplete','hasRecommendations']),
      ...mapState('contacts', ['tags']),
      ...mapState("ui", ["locale"]),
    },
    watch: {
      item() {
        this.prepare();
      }
    },
    methods: {
      async sendPreview() {
        if(!this.isActive) {
          this.$store.dispatch('ui/notify', { error: true, text: this.$t('campaigns.notify.inactive')});
          return;
        }
        if(this.isIncomplete) {
          this.$store.dispatch('ui/notify', { error: true, text: this.$t('campaigns.notify.incomplete')});
          return;
        }
        if(!this.hasRecommendations && this.hasProductsInTemplate) {
          this.$store.dispatch('ui/notify', { error: true, text: this.$t('campaigns.notify.noProducts')});
          return;
        }
        this.sending = true;
        let success = await this.$store.dispatch('campaigns/sendTestEmail', {email: this.recipient, campaignID: this.item.id, variantID: this.previewVariant });
        this.sending = false;
        this.$store.dispatch('ui/notify', { error: !success, text: success ? this.$t('campaigns.notify.previewSent') : this.$t('campaigns.notify.previewError')});
      },
      setStartDate() {
        /*let d = new Date(this.startPickerDate);
        let [h,m] = this.startPickerTime.split(':');
        d.setHours(h,m);
        */
        
       let d = this.getUTCDate(`${this.startPickerDate}T${this.startPickerTime}`, this.item.domain.timezone);
        this.startPicker = false;
        console.debug(`Campaing start date: ${d.toISOString()}`, d);
        this.startDate = d;
      },
      loadRecipients() {
        if(!this.item || this.item?.scheduleType == 'BACK_TO_CART') {
          return;
        }
        this.recipientsLoading = true;
        this.$store.dispatch('campaigns/loadRecipients').then(() => { this.recipientsLoading = false });
      },
      savePriority(changes) {
        if(changes.length != 1) {
          return;
        }
        this.fields.priority = changes[0].priority;
        this.priorityMenu = false;
      },
      initFields() {
        if(!this.item) {
          return;
        }
        if(this.item.schedule?.start) {
          this.startDate = new Date(this.item.schedule.start);
        }
        if(this.item.schedule?.delay != null) { // 0 is valid value
          this.delayIndex = this.delays.findIndex(d => d.value == this.item.schedule.delay);
        }
        if(this.item.schedule?.frequency) {
          this.frequencyIndex = this.frequencies.findIndex(d => d.value == this.item.schedule.frequency);
        }
      },
      prepareFields(nowizard) {
        let result = true;
        let error = null;
        
        if(!nowizard) {
          if(!this.hasRecommendations && this.hasProductsInTemplate) {
            result = false;
            error = this.$t('campaigns.notify.noProducts');
          }
          
          if(this.isIncomplete) {
            result = false;
            error = this.$t('campaigns.notify.incomplete');
          }
          if(!this.isActive) {
            result = false;
            error = this.$t('campaigns.notify.inactive');
          }
        }
        
        if(this.isAutomatic) {
          
          // set schedule frequency
          
          if(this.frequencyIndex == null) {
            result = false;
            error = this.$t('campaigns.automatic.frequency.error');
          } else {
            this.fields.schedule = { frequency: this.frequencies[this.frequencyIndex].value, start: this.item.schedule?.start || new Date().toISOString() };
          }
          // set state SENDING - IF There is no error (this is to prevent bug when user clicks Next, the fields are modified, 
          // and then clicks Save which do not perform the check and fields are changed and campaign is started)
          if(!nowizard && result) {
            this.fields.state = 'WAITING';
          }
        }
        if(this.isScheduled) {
          // set state WAITING
          if(!nowizard && result) {
            this.fields.state = 'WAITING';
          }
          // set schedule start
          this.fields.schedule = { start: this.startDate ? this.startDate.toISOString() : new Date().toISOString() };
        }
        console.debug('swu', this.isSWU);
        if(this.isSWU) {
          // set state WAITING
          if(!nowizard && result) {
            this.fields.state = 'WAITING';
          }
          // set schedule start
          this.fields.schedule = { 
            start: this.startDate ? this.startDate.toISOString() : new Date().toISOString(),
            next: new Date(0),
            last: new Date(0)
          };
          console.debug('swu schedule', this.fields.schedule);
        }
        
        if(this.isBTC || this.isWelcome) {
          if(this.delayIndex == null) {
            result = false;
            error = this.$t('campaigns.btc.delay.error');
          } else if (this.isBTC && this.delayIndex == 0) {
            result = false;
            error = this.$t('campaigns.btc.delay.errorNoDelay');
          } else {
            // set schedule frequency
            this.fields.schedule = { delay: this.delays[this.delayIndex].value, start: this.item.schedule?.start || new Date().toISOString };
          }
          if(!nowizard && result) {
            this.fields.state = 'SENDING';
          }
        }
        if(!result) {
          this.$store.dispatch('ui/notify', { error: true, text: error });
        }
        return result;
      },
      prepare() {
        this.loadRecipients();
        this.initFields();
        if(!this.listAutomatic && this.isAutomatic) {
          this.$store.dispatch("campaigns/list", { domainID: this.item.domainID, sortDirection: 'DESC' });
        }
        if(this.isTag) {
          this.$store.dispatch("contacts/listTags", { domainID: this.item.domainID });
        }
      }
    },

    created() {
      this.$store.commit('ui/wizard', {value: true });
      this.setLastEditableStep();
      this.prepare();
    }
  }
</script>